import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Button } from "antd";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import DataFreightControlTable from "./components/data-freight-control-table";
import shipperService from "../../service/shipper.service";
import { getShipperDocCached } from "../../util/shipper/shipperDocCache";

import { canViewFreightControlPanel } from "../../util/freight/freight-control-permissions";

require("firebase/auth");

const ADVANCE_WHATSAPP_PHONE = "5581983422993";

function resolveShipperCompanyName(shipperData) {
  const data = shipperData || {};
  const personal = data.dataPersonal || {};
  return (
    String(personal.nameFantasy || "").trim() ||
    String(personal.socialName || "").trim() ||
    String(data.nameFantasy || "").trim() ||
    String(data.socialName || "").trim() ||
    ""
  );
}

function openAdvanceWhatsApp(companyName) {
  const name = String(companyName || "").trim() || "minha empresa";
  const message = `Olá gostaria de saber mais sobre a antecipação dos meus boletos: ${name}`;
  window.open(
    `https://wa.me/${ADVANCE_WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`,
    "_blank",
    "noopener,noreferrer",
  );
}

function FreightControlPanel() {
  const userLogado = useSelector((state) => state.usuarioLogado);
  const user = useSelector((state) => state.user);
  const [cleanFilters, setCleanFilters] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const [companyName, setCompanyName] = useState("");

  const canView = canViewFreightControlPanel(user);

  useEffect(() => {
    if (userLogado > 0) return;
  }, [userLogado]);

  useEffect(() => {
    const shipperId = String(user?.uidShipper || "").trim();
    if (!shipperId) {
      setCompanyName("");
      return undefined;
    }

    let cancelled = false;

    getShipperDocCached(shipperId, async () => {
      const snap = await shipperService.getShipperAvailable(shipperId);
      return snap?.exists ? snap.data() : null;
    })
      .then((data) => {
        if (!cancelled) setCompanyName(resolveShipperCompanyName(data));
      })
      .catch(() => {
        if (!cancelled) setCompanyName("");
      });

    return () => {
      cancelled = true;
    };
  }, [user?.uidShipper]);

  if (userLogado <= 0) {
    return <Navigate to="/login" />;
  }

  if (!canView) {
    return <Navigate to="/" />;
  }

  return (
    <NewMiniDrawer
      divOpen={
        <div className="freight-content">
          <div
            className="container"
            style={{ marginRight: "unset", marginLeft: "unset" }}
          >
            <div
              className="row"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 12,
              }}
            >
              <div>
                <h3 style={{ margin: 0 }}>Faturas</h3>
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <Button
                  type="primary"
                  onClick={() => setCleanFilters(!cleanFilters)}
                  className="btn-limpar-filtros"
                >
                  Limpar Filtros
                </Button>
                <Button onClick={() => setOpenFilters(!openFilters)}>
                  Filtros Salvos
                </Button>
                <Button
                  type="primary"
                  onClick={() => openAdvanceWhatsApp(companyName)}
                >
                  Antecipe seu boleto
                </Button>
              </div>
            </div>
            <br />
            <br />
          </div>
          <DataFreightControlTable
            cleanFilter={cleanFilters}
            openFilter={openFilters}
            onCleanFilterHandled={() => setCleanFilters(false)}
            onOpenFilterHandled={() => setOpenFilters(false)}
          />
        </div>
      }
    />
  );
}

export default FreightControlPanel;

export {
  sendFreightInvoiceBoletoFromPanel,
  sendFreightInvoiceChargeFromPanel,
} from "./freightInvoiceEmailHandlers";
